import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { apiClient } from "@/config/api";

import {
  CreateReportBody,
  GetHomeownerReportsRequest,
  GetHomeownerReportsResponse,
  RecentReportsResponse,
} from "./types";

export const createReport = createAsyncThunk(
  "/reports/bulk",
  async (body: CreateReportBody, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      // Prepare the reports data without files for the JSON field

      formData.append("reports", JSON.stringify(body.reports));

      // Attach files with the expected format (file_0, file_1, etc.)
      body.files.forEach((file, index) => {
        formData.append(`file_${index}`, file);
      });

      const response = await apiClient.post("/reports/bulk", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Create report failed"
        );
      }
      return rejectWithValue("Create report failed");
    }
  }
);

export const getHomeownerReports = createAsyncThunk(
  "reports/homeowner",
  async (params: GetHomeownerReportsRequest, { rejectWithValue }) => {
    try {
      const { homeownerId, ...queryParams } = params;

      const cleanParams = Object.fromEntries(
        Object.entries(queryParams).filter(([, value]) => value != null)
      );

      const response = await apiClient.get<{
        data: GetHomeownerReportsResponse;
      }>(`/reports/homeowner/${homeownerId}`, { params: cleanParams });
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Get homeowner reports failed"
        );
      }
      return rejectWithValue("Get homeowner reports failed");
    }
  }
);

export const getRecentReports = createAsyncThunk(
  "reports/recent",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get<{ data: RecentReportsResponse }>(
        "/reports/recent"
      );
      return response.data.data.reports;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Get recent reports failed"
        );
      }
      return rejectWithValue("Get recent reports failed");
    }
  }
);

export const deleteReport = createAsyncThunk(
  "reports/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await apiClient.delete(`/reports/${id}`);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Delete report failed"
        );
      }
      return rejectWithValue("Delete report failed");
    }
  }
);
